import { getNumberOfGridColumnsMd } from "@repo/lib/helpers";
import { ProductCard } from "@repo/ui";
const ProductGrid = props => {
  const {
    products,
    wishlistItems,
    session,
    initialColumns = "2",
    categorySlug,
    collectionName,
    spaceSlug
  } = props;
  return <div className={`grid grid-cols-2 gap-4 md:gap-5 ${getNumberOfGridColumnsMd(initialColumns)}`} data-sentry-component="ProductGrid" data-sentry-source-file="ProductGrid.jsx">
      {products?.map(product => <ProductCard key={product?.id} product={product} wishlistItems={wishlistItems} session={session} collectionName={collectionName} categorySlug={categorySlug} spaceSlug={spaceSlug} />)}
    </div>;
};
export default ProductGrid;